import { render, staticRenderFns } from "./ExpiringPointLogs.vue?vue&type=template&id=47e8defc&scoped=true&"
import script from "./ExpiringPointLogs.vue?vue&type=script&lang=js&"
export * from "./ExpiringPointLogs.vue?vue&type=script&lang=js&"
import style0 from "./ExpiringPointLogs.vue?vue&type=style&index=0&id=47e8defc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8defc",
  null
  
)

export default component.exports